const checkStringStartsWith = token => key => typeof key === "string" && key.startsWith(token);
const isCSSVariableName = checkStringStartsWith("--");
const isCSSVariableToken = checkStringStartsWith("var(--");
export { isCSSVariableName, isCSSVariableToken };